import { useToastContext } from "components/alert/ToastContext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useLoadingContext } from "provider/LoadingProvider";
import MetaProducaoService from "service/meta/producao/MetaProducaoService";
import saveAs from 'file-saver';
import { useEffect, useState } from "react";
import MetaPorUsuarioRelatorioFilters from "model/meta/producao/MetaPorUsuarioRelatorioFilters";
import { Dropdown } from "primereact/dropdown";
import Usuario from "model/administracao/cadastro/Usuario";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { set } from "date-fns";
import { Label } from "components/input/Label";

type Props = {
    visible: boolean;
    onHide: () => void;
}

const metaProducaoService = new MetaProducaoService();
export default function ModalRelatorioMetaPorUsuario(props: Props) {

    const { msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [filters, setFilters] = useState(new MetaPorUsuarioRelatorioFilters());

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    useEffect(() => {
        metaProducaoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });
    }, [])

    const handleConfirm = () => {
        if (!validar()) {
            return;
        }
        gerarRelatorio();
    }

    const validar = () => {
        if (!filters.inicioPeriodo || !filters.fimPeriodo) {
            msgAlerta("Alerta", "Data inicial e final são obrigatórias.");
            return false;
        }
        if (filters.inicioPeriodo > filters.fimPeriodo) {
            msgAlerta("Alerta", "A data inicial não pode ser maior que a data final.");
            return false;
        }
        return true;
    }

    const gerarRelatorio = () => {
        startLoading();
        metaProducaoService.gerarRelatorioMetaPorUsuario(filters).then((data) => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Metas.pdf`);
        }).catch((err) => {
            msgErro("Erro", err?.data?.message || "Ocorreu um erro ao gerar relatório de meta por usuário.");
            stopLoading();
            console.error(err);
        });
    }

    return (
        <Dialog
            header="Gerar relatório de meta por usuário"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Gerar" icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Label htmlFor="usuario">Usuário</Label>
                    <Dropdown
                        filter
                        filterBy="nome"
                        value={filters.usuario}
                        options={usuarios}
                        optionLabel="nome"
                        onChange={(e) => setFilters({ ...filters, usuario: e.value })}
                        placeholder="Selecione um usuário"
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Label obrigatorio htmlFor="inicioPeriodo">Período</Label>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
                        <DatePicker
                            slotProps={{ popper: { disablePortal: true } }}
                            value={dayjs(filters.inicioPeriodo)}
                            onChange={value => {
                                setFilters({ ...filters, inicioPeriodo: value ? value.toDate() : null })
                            }}
                        />
                        <DatePicker
                            slotProps={{ popper: { disablePortal: true } }}
                            value={dayjs(filters.fimPeriodo)}
                            onChange={value => {
                                setFilters({ ...filters, fimPeriodo: value ? value.toDate() : null })
                            }}
                        />
                    </div>
                </div>

            </div>
        </Dialog>
    )
}